import { Link } from "react-router-dom";
import { MapPin, MessageCircle, QrCode } from "lucide-react";
import { waLink } from "@/lib/api";
import { formatWa, useStoreInfo } from "@/lib/store";

export const Footer = () => {
  const store = useStoreInfo();
  return (
  <footer className="mt-20 border-t border-stone-200 bg-white">
    <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 md:grid-cols-3 md:px-6">
      <div>
        <p className="text-lg font-semibold">EllMom Handmade</p>
        <p className="mt-2 max-w-xs text-sm text-stone-600">Kerajinan tangan dan perlengkapan craft, dikemas dengan cinta dari Tangerang.</p>
      </div>
      <div className="space-y-3 text-sm text-stone-600">
        <p className="flex gap-2"><MapPin className="h-4 w-4 shrink-0 text-amber-700" /> {store.address}</p>
        <a data-testid="footer-wa-link" href={waLink("Halo EllMom Handmade, saya ingin bertanya.", store.admin_whatsapp)} target="_blank" rel="noreferrer" className="flex gap-2 hover:text-amber-700">
          <MessageCircle className="h-4 w-4 shrink-0 text-amber-700" /> {formatWa(store.admin_whatsapp)}
        </a>
        <p className="flex gap-2"><QrCode className="h-4 w-4 shrink-0 text-amber-700" /> Bayar QRIS, terverifikasi otomatis</p>
      </div>
      <div className="flex flex-col gap-2 text-sm">
        <Link to="/#katalog" className="text-stone-600 hover:text-amber-700">Katalog</Link>
        <Link to="/lacak" className="text-stone-600 hover:text-amber-700">Lacak Pesanan</Link>
        <Link to="/pesanan-saya" data-testid="footer-my-orders-link" className="text-stone-600 hover:text-amber-700">Pesanan Saya</Link>
      </div>
    </div>
    <p className="border-t border-stone-100 py-4 text-center text-xs text-stone-500">© {new Date().getFullYear()} EllMom Handmade</p>
  </footer>
  );
};

export const WhatsAppFab = () => {
  const store = useStoreInfo();
  return (
  <a data-testid="whatsapp-fab" href={waLink("Halo EllMom Handmade, saya ingin bertanya tentang produk.", store.admin_whatsapp)} target="_blank" rel="noreferrer"
    className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-green-600 px-4 py-3 text-sm font-medium text-white shadow-lg hover:bg-green-700">
    <MessageCircle className="h-5 w-5" /> <span className="hidden sm:inline">Chat CS</span>
  </a>
  );
};
